import { useMutation, UseMutationConfig } from '@libs/use';
import { EmbeddedPutOptionRequestBody } from '@libs/api-reference';

import * as API from '../../requests';

type UseUpdateEmbeddedPutOptionRequestOptions = {
  isin: string;
  onReject?: UseMutationConfig<object>['onReject'];
  onSuccess?: UseMutationConfig<object>['onSuccess'];
};

export default function useUpdateEmbeddedPutOptionRequestQuery({
  isin,
  onReject,
  onSuccess,
}: UseUpdateEmbeddedPutOptionRequestOptions) {
  const {
    execute: updateEmbeddedPutOptionRequest,
    isPending: isLoadingUpdateEmbeddedPutOptionRequest,
    ...query
  } = useMutation(
    ({ formModel }: { formModel: EmbeddedPutOptionRequestBody }) =>
      API.updateEmbeddedPutOptionRequest(isin, formModel),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    updateEmbeddedPutOptionRequest,
    isLoadingUpdateEmbeddedPutOptionRequest,
    ...query,
  };
}
